import { useQuery } from 'react-query'
import { fetcher } from 'src/fetcher'
import { BASE_API_URL } from 'src/globals'
import { AppointmentProfile } from 'src/types'
import { useUserInfo } from './useUserInfo'
import { getOfferingsParams, IGetOfferingsParams } from 'src/utils'

export function fetchOfferings({
    profileNames,
    patientId
}: IGetOfferingsParams) {
    return async () => {
        if (!patientId) {
            console.warn(
                'useOfferings.fetchOfferings called without patientId, returning empty array'
            )
            return []
        }
        const offeringsData: AppointmentProfile[] = await fetcher(
            `${BASE_API_URL}/schedule-api/api/v1/offerings${getOfferingsParams({
                patientId,
                profileNames
            })}`,
            undefined,
            'GET',
            {
                errorMsg: 'Error fetching profiles'
            }
        )

        return profileNames
            ? offeringsData.sort(
                  (a, b) =>
                      profileNames.indexOf(a.name) -
                      profileNames.indexOf(b.name)
              )
            : offeringsData.sort((a, b) => (a.label > b.label ? 1 : -1))
    }
}

export function useOfferings(profileNames?: string[]) {
    const { user } = useUserInfo()
    const offerings = useQuery<AppointmentProfile[]>(
        ['offerings', profileNames, user?.id],
        fetchOfferings({ profileNames, patientId: user?.id }),
        {
            staleTime: Infinity,
            enabled: !!user?.id
        }
    )

    return {
        offerings: offerings.data,
        isLoading: offerings.isLoading
    }
}
